import type { FunctionComponent } from 'react';

import { defineMessages, FormattedMessage } from 'react-intl';
import SectionMessage from '@atlaskit/section-message';

const messages = defineMessages({
  warningFirstLine: {
    id: 'applinks.warning.v2',
    defaultMessage:
      'By allowing this, you can use {appName} without storing your {appName} password in {clientName}.',
    description:
      'Warning for applinks that ensures the user knows what accepting this consent will do',
  },
});

const Warning: FunctionComponent<{ clientName: string; appName: string }> = ({
  clientName,
  appName,
}) => (
  <SectionMessage appearance="warning">
    <p></p>
    <FormattedMessage
      {...messages.warningFirstLine}
      values={{
        clientName: <strong>{clientName}</strong>,
        appName: <strong>{appName}</strong>,
      }}
    />
  </SectionMessage>
);

export default Warning;
